import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { useLocalization } from '../context/LocalizationContext';
import '../styles/Auth.css';
import '../styles/Maintenance.css';

export const Maintenance: React.FC = () => {
  const { t } = useLocalization();

  return (
    <div className="auth-container">
      <Container className="auth-page-shell">
        <div className="auth-card-wrapper">
          <Card className="auth-card">
            <Card.Body>
              <div className="maintenance-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <h2 className="text-center auth-title mb-1">{t('maintenanceTitle')}</h2>
              <p className="text-center auth-subtitle mb-4">{t('maintenanceMessage')}</p>
              <div className="maintenance-content text-center">
                <p className="text-muted mb-3">{t('maintenanceExpected')}</p>
                <p className="text-muted small">{t('maintenanceContact')}</p>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default Maintenance;
